import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController, NavParams } from '@ionic/angular';
import { AbstractPage } from 'src/app/AbstractPage';



@Component({
  template: `
    <ion-header>
        <ion-toolbar color="primary">       
            <ion-title class="iosTitleToolbarLeft">{{ 'storico-rilevazioni.label.downloadReport' | translate }}</ion-title>
            <ion-buttons slot="end">
                <ion-button class="ion-text-capitalize" slot="end" (click)="annulla()" title="{{'label.cancel'|translate}}">{{'label.cancel'|translate}}
                  <ion-icon name="arrow-undo-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </ion-header>

    <ion-content>
        <div class="title">
            <p>{{ 'storico-rilevazioni.label.selectDate' | translate }}</p>
        </div>
        <div class="datetime">
            <ion-card class="datetime-card">
                <ion-card-content>
                    <ion-datetime [(ngModel)]="selectedDate" presentation="date" min="{{minDate}}" max="{{anno == annoAttuale ? now : maxDate}}"></ion-datetime>
                </ion-card-content>
            </ion-card>
        </div>
        <div class="ion-padding button-salva">
            <ion-button class="note-button" (click)="esporta()">
                <ion-label>{{ 'report.button.export' | translate }}</ion-label>
            </ion-button>
        </div>
    </ion-content>`,
    styles: [`
        .title {
            margin-top: 30px;
            margin-left: 20px;
            margin-bottom: 30px;
        }

        .datetime-card {
            height: 65%;
            width: 60%;
        }

        .datetime {
            display: flex;
            justify-content: center;
        }

        .button-salva {
            display: flex;
            justify-content: flex-end;
        }
    `],
    standalone: false
})
export class ReportComponent extends AbstractPage implements OnInit {

    @Input() anno: String;
    now: String = new Date().toISOString();
    selectedDate: String = null;
    annoAttuale: String = this.now.split('-')[0];
    maxDate: String;
    minDate: String;

    constructor(
      public modalCtrl: ModalController,
      public navCtrl: NavController,
              public navParams: NavParams,
              public router: Router,
      ) {
        super(navCtrl, router);
      }

    ngOnInit() {
        this.minDate = new Date(this.anno + '-01-01').toISOString();
        this.maxDate = new Date(this.anno + '-12-31').toISOString();
        console.log('ngOnInit ReportComponent');
    }

    async esporta() {
        if(this.selectedDate) {
            await this.modalCtrl.dismiss(this.selectedDate, 'cancel');
        } 
        else {
           await this.modalCtrl.dismiss('', 'cancel'); 
        }
    }

    async annulla() {
        await this.modalCtrl.dismiss(null, 'cancel');
    }
}